"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MapPanel = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.search.js");
require("core-js/modules/es.array.reduce.js");
var _react = _interopRequireWildcard(require("react"));
var _KeyboardArrowDownRounded = _interopRequireDefault(require("@mui/icons-material/KeyboardArrowDownRounded"));
var _reactBootstrap = require("react-bootstrap");
var _material = require("@mui/material");
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _MapLayoutGrid = require("./MapLayoutGrid");
var _selectors = require("../../redux/selectors");
var _actions = require("../../redux/actions");
var _MapPanelModule = _interopRequireDefault(require("../../styles/components/MapPanel/MapPanel.module.css"));
var _hooks = require("../../hooks");
var _constants = require("../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const CustomToggle = _ref => {
  let {
    _,
    eventKey
  } = _ref;
  const decoratedOnClick = (0, _reactBootstrap.useAccordionButton)(eventKey, () => setIsOpen(!isOpen));
  const [isOpen, setIsOpen] = (0, _react.useState)(true);
  return /*#__PURE__*/_react.default.createElement(_material.Button, {
    type: "link",
    disableTouchRipple: true,
    className: "".concat(isOpen ? _MapPanelModule.default.isOpen : '', " w-100 h-100"),
    onClick: decoratedOnClick
  }, /*#__PURE__*/_react.default.createElement(_KeyboardArrowDownRounded.default, {
    className: "color-main-color-primary"
  }));
};
const selectOptionLabelParams = {
  thingSiteAddress: {
    type: _constants.valueTypes.string
  },
  thingZIPCode: {
    type: _constants.valueTypes.number
  },
  thingCity: {
    type: _constants.valueTypes.string
  }
};
const MapPanel = /*#__PURE__*/(0, _react.memo)(_ref2 => {
  let {
    nameForm
  } = _ref2;
  const dispatch = (0, _reactRedux.useDispatch)();
  const filter = (0, _reactRedux.useSelector)((0, _selectors.getFiltersByFormName)(nameForm));
  const sites = (0, _reactRedux.useSelector)(_selectors.getDataSiteValuesByID, (prev, next) => _paulCorePackage.functions.areEqual(prev, next));
  const tI = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsInterfaceUILocalizations);
  const sortedSites = (0, _hooks.useSortSites)({
    sites,
    sortParams: selectOptionLabelParams
  });
  const handleGetActiveFilters = (0, _react.useCallback)(data => {
    dispatch((0, _actions.setFilters)({
      filter: data,
      name: nameForm
    }));
  }, [dispatch, nameForm]);
  const handleGetFilteredData = (0, _react.useCallback)(data => {
    dispatch((0, _actions.setFilteredSites)({
      data,
      name: nameForm
    }));
  }, [dispatch, nameForm]);
  const filterConfig = (0, _react.useMemo)(() => [{
    defaultValue: tI[25],
    // 'City'
    type: _paulCorePackage.constants.filterTypes.select,
    name: 'thingCity',
    id: 1
  }, {
    defaultValue: tI[26],
    // 'Zip'
    type: _paulCorePackage.constants.filterTypes.select,
    name: 'thingZIPCode',
    id: 2
  }, {
    type: _paulCorePackage.constants.filterTypes.search,
    placeholder: tI[27],
    // 'Enthält Text'
    sx: {
      maxWidth: 500
    },
    option: (item, tv) => Object.keys(selectOptionLabelParams).reduce((acc, param) => acc ? "".concat(acc, ", ").concat(tv(item[param]) || '-') : tv(item[param]) || '-', ''),
    id: 3
  }], [tI]);
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Accordion, {
    defaultActiveKey: "0",
    className: _MapPanelModule.default.container
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Card, {
    className: _MapPanelModule.default.card
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Card.Header, {
    className: _MapPanelModule.default.card_header
  }, /*#__PURE__*/_react.default.createElement(CustomToggle, {
    eventKey: "0"
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Accordion.Collapse, {
    eventKey: "0"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Card.Body, {
    className: _MapPanelModule.default.card_body
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, {
    fluid: "md",
    className: _MapPanelModule.default.container_md
  }, /*#__PURE__*/_react.default.createElement(_paulCorePackage.Filters, {
    className: "mb-20",
    config: filterConfig,
    data: sortedSites,
    activeFilters: filter,
    getActiveFilters: handleGetActiveFilters,
    getFilteredData: handleGetFilteredData
  }, /*#__PURE__*/_react.default.createElement(_MapLayoutGrid.MapLayoutGrid, null)))))));
});
exports.MapPanel = MapPanel;
MapPanel.propTypes = {
  nameForm: _propTypes.default.string
};